import React, { useContext } from 'react'
import {
  arrayOf,
  bool,
  exact,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from 'prop-types'
import * as Styled from './QsrHeader.styles'
import DOMPurify from 'dompurify'

// component stack
import { QsrIndicator } from 'components/molecules'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { Tooltip } from 'components/atoms'
import { getQsrValueByScoring } from 'settings/app/helpers'

const QsrHeader = ({ data, showDetails, showHeadline }) => {
  const textContext = useContext(TextContext)
  const { headline, qsrHeaderText, status } = data

  let result
  let explanation

  if (data.table?.length > 0 && (status === 0 || status === 2)) {
    result = data.table[0].result
    explanation = data.table[0].explanation
  }

  return (
    <Styled.QsrHeader>
      {showHeadline && (
        <div className='headline'>
          <span>{textContext['indicatorTable.qsr.header']}</span>
          <span>»{headline}«</span>
        </div>
      )}
      <div
        className={ `headline-details ${
          showHeadline ? 'headline-details--treatment' : ''
        }` }>
        {showHeadline && (
          <div>
            <span className='headline'>
              {textContext['quality.headline.qsr']}
            </span>
            {data.tooltip && (
              <Tooltip
                arrow='left'
                className='tooltip'
                dialogTitle={ textContext['quality.headline.qsr'] }
                infoIconId={ `info-icon` }
                tooltipId={ `tooltip` }>
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(data.tooltip),
                  }}
                />
              </Tooltip>
            )}
          </div>
        )}
        {result && (status === 0 || status === 2) && (
          <span className='row-item'>
            <QsrIndicator
              size={ 32 }
              className='qsr-indicator'
              currentLevel={ getQsrValueByScoring(result) }
              maxLevel={ 3 }
            />
          </span>
        )}
        <p
          className='result'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(qsrHeaderText),
          }}
        />
        {showDetails && (status === 0 || status === 2) && (
          <span className='row-item result'>
            Gesamtbewertung für diesen Leistungsbereich: {result.value}{' '}
            {result.range}
          </span>
        )}
        {explanation && (status === 0 || status === 2) && (
          <span className='row-item result'>
            {!showDetails
              ? explanation[result.rating].text
              : explanation[result.rating].textDetailed}
          </span>
        )}
        {showDetails && (status === 0 || status === 2) && (
          <>
            {explanation.value && (
              <span className='row-item result'>{explanation.value}</span>
            )}
            {explanation.range && (
              <span className='row-item result'>{explanation.range}</span>
            )}
          </>
        )}

        {data?.info && <span className='row-item result'>{data.info}</span>}
      </div>
    </Styled.QsrHeader>
  )
}

QsrHeader.defaultProps = {
  showHeadline: true,
  showDetails: false,
}

QsrHeader.propTypes = {
  data: shape({
    copy: string.isRequired,
    id: string,
    headline: string.isRequired,
    status: oneOf([0, 1, 2]).isRequired,
    tooltip: string,
    table: arrayOf(
      shape({
        indicator: string.isRequired,
        tooltip: shape({
          title: string.isRequired,
          tip: string.isRequired,
        }).isRequired,
        result: exact({
          rating: string.isRequired,
          value: oneOfType([string, number]),
          range: string.isRequired,
        }).isRequired,
        explanation: exact({
          low: shape({
            title: string.isRequired,
            text: string.isRequired,
          }).isRequired,
          average: shape({
            title: string.isRequired,
            text: string.isRequired,
          }).isRequired,
          high: shape({
            title: string.isRequired,
            text: string.isRequired,
          }).isRequired,
          /** this strings will shown when user clicked on showDetails **/
          value: string,
          range: string,
        }),
      })
    ),
  }),
  showDetails: bool,
  showHeadline: bool,
}

export default QsrHeader
